module.exports = __webpack_public_path__ + "img/edit_icon.449712e4.svg";